

















    
import {Vue, Component, Prop} from 'vue-property-decorator';
import { Address } from '../../services/accounting.service';

@Component({})
export default class AddressDisplay extends Vue {
    @Prop()
    public address!: Address;

    @Prop({type: String, default: 'simple'})
    public type!: string;
}

